import { Grid, TextField, MenuItem } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormContent } from 'scenes/Producer/Product/EditProduct/components/FormContent';
import styles from 'scenes/Producer/Product/NewProduct/components/Forms/styles';
import { getDeliveryIntegrationActiveList } from 'store/Orbita/Product/actions';
import ProductService from 'store/Orbita/Product/services';
import { EChargeType } from 'v2/interfaces/product';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import Correios from './Form/Correios';
import FixedValue from './Form/FixedValue';
import Free from './Form/Free';
import MelhorEnvio from './Form/MelhorEnvio';
import Partner from './Form/Partner';

import type { IrregularProduct } from '../../MyProducts/constants';
import type IProduct from 'interfaces/IProduct';
import type { DispatchProp } from 'react-redux';

const FREE = '1';
const FIXEDVALUE = '2';
const CORREIOS = '3';
const MELHORENVIO = '4';

interface IProps extends DispatchProp<any> {
  delivery: any;
  enabledValidation?: boolean;
  onAddPartner?: any;
  onRemovePartner?: any;
  onChangeRequiredFields?: any;
  loading?: boolean;
  onEdit?: any;
  ref?: any;
  fade?: any;
  setRefField?: any;
  product?: IProduct;
  integration: any;
}

interface IStates {
  showErrors: boolean;
  validationErrors: any;
  pending_actions: IrregularProduct['pending_actions'];
}

class PhysicalDeliveryMethods extends Component<IProps, IStates> {
  constructor(props: any) {
    super(props);
    this.state = {
      showErrors: false,
      validationErrors: [],
      pending_actions: null,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };
  handleChange(prop: string, value: any) {
    let { delivery } = this.props;
    delivery[prop] = value;

    if (prop === 'delivery_type' && value === MELHORENVIO) {
      this.getIntegrations();
    }

    this.props.dispatch({ type: 'CHANGE_PHYSICAL_DELIVERY', delivery });
  }

  changeState = () => {
    let { onChangeRequiredFields } = this.props;
    if (onChangeRequiredFields) {
      onChangeRequiredFields();
    }
  };
  componentDidUpdate(prevProps: IProps) {
    if (!this.props.loading && this.props.delivery !== prevProps.delivery) {
      this.changeState();
    }
  }

  getIntegrations() {
    this.props.dispatch(getDeliveryIntegrationActiveList());
  }

  componentDidMount() {
    if (!this.props.loading && this.props.enabledValidation) {
      this.changeState();
    }
    this.getIntegrations();
    this.loadIrregularProduct();
  }

  getActionsMessage = (pending_actions: IrregularProduct['pending_actions']) => {
    const messages = [];

    if (pending_actions.invalid_physical_dimensions) {
      messages.push(
        <div style={{ paddingBottom: 8 }}>
          <Alert severity='info'>
            <b>Ajuste necessário nas dimensões dos produtos físicos</b>
            <br />
            Devido às restrições de dimensões de embalagens estabelecidas pelos Correios, é necessário que você ajuste as dimensões de seus produtos
            até <b>31/10/2024</b>. Após essa data, faremos o ajuste automático, aplicando as dimensões máximas permitidas pelos Correios. Os valores
            máximos estão especificados nos campos. Sem essa ação, o checkout será impactado e suas vendas poderão ser afetadas.
          </Alert>
        </div>
      );
    }

    return messages;
  };

  loadIrregularProduct = async () => {
    const productId = String(this.props.product.id);
    await ProductService.listIrregularProducts({ per_page: 20, current_page: 1 }, productId).then((result) => {
      const { data } = result.data;
      !!data.length && this.setState((prevState) => ({ ...prevState, pending_actions: data[0].pending_actions }));
    });
  };

  render() {
    const { delivery, enabledValidation, onAddPartner, onRemovePartner, product, integration, onEdit } = this.props;
    const { pending_actions } = this.state;
    const isSubscription = product?.charge_type === EChargeType.SUBSCRIPTION;

    return (
      <FormContent title='Entrega' loading={false}>
        <Grid container spacing={2}>
          {pending_actions && (
            <Grid item xs={12}>
              {this.getActionsMessage(pending_actions)}
            </Grid>
          )}
          <Grid item xs={12}>
            <SelectType delivery={delivery} product={product} onChange={this.handleChange} />
          </Grid>
          {!isSubscription && delivery?.delivery_type == CORREIOS && <Correios onEdit={onEdit} enabledValidation={enabledValidation} />}
          {!isSubscription && delivery?.delivery_type == MELHORENVIO && (
            <MelhorEnvio
              onEdit={onEdit}
              delivery={delivery}
              integration={{
                logisticType: integration.logisticType,
                status: integration.status,
              }}
            />
          )}
          {delivery.delivery_type === FREE && <Free onEdit={onEdit} enabledValidation={enabledValidation} />}
          {delivery.delivery_type === FIXEDVALUE && <FixedValue onEdit={onEdit} enabledValidation={enabledValidation} />}
          {!delivery.new && <Partner onEdit={onEdit} onAddPartner={onAddPartner} onRemovePartner={onRemovePartner} />}
        </Grid>
      </FormContent>
    );
  }
}
function mapStateToProps(state: any) {
  return {
    delivery: state.components.physicalDelivery,
    integration: state.orbita.Product.getDeliveryIntegrationActiveList,
  };
}

const SelectType = ({ delivery, product, onChange }: { delivery: any; product: IProduct; onChange: (field: string, value: string) => void }) => {
  const isBeta = eduzzAccountsService.verifyUserHasBetaModule('delivery_melhor_envio');
  const isSubscription = product?.charge_type === EChargeType.SUBSCRIPTION;
  return (
    <TextField
      id='delivery_type'
      select
      fullWidth
      value={delivery.delivery_type}
      onChange={(e: any) => onChange('delivery_type', e.target.value)}
      label='Tipo de frete'
      InputProps={{
        disableUnderline: true,
      }}
      InputLabelProps={{
        shrink: true,
      }}
    >
      {!isSubscription && <MenuItem value={CORREIOS}>Correios</MenuItem>}
      {!isSubscription && isBeta && <MenuItem value={MELHORENVIO}>Melhor Envio</MenuItem>}
      <MenuItem value={FREE}>Frete Grátis</MenuItem>
      <MenuItem value={FIXEDVALUE}>Valor Fixo</MenuItem>
    </TextField>
  );
};

export default styles(connect(mapStateToProps)(PhysicalDeliveryMethods)) as any;
